import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { BOOKING_CREATE_OR_UPDATE_PAGE_REQUEST, BOOKING_CREATE_REQUEST, BOOKING_DELETE_REQUEST, BOOKING_EDIT_PAGE_REQUEST, BOOKING_PROJECT_OPTIONS_REQUEST, BOOKING_REQUEST, NAVIGATION_REQUEST } from "../../redux/action_constant";
import WebService from "../../utility/WebService";
import API from "../../utility/API-endPoints";
import { bookingDeleteFailure, bookingDeleteSuccess, bookingEditPageSuccess, bookingFailure, bookingProjectOptionsFailure, bookingProjectOptionsRequest, bookingProjectOptionsSuccess, bookingSuccess } from "./BookingsAction";
import { BookingEditPageRequest, BookingInterface, BookingRequestPayload, BookingRequest, BookingRequestFailure, BookingRequestSuccessPayload, BookingState, ProjectOptionInterface, bookingAddOrEditRequestPayload, BookingCreateRequest, createOrUpdateBookingInterface } from "./BookingTypes";
import routePaths from "../../Navigation/routePaths";
import { reduxInitialState } from "../onBoarding/onBoardingTypes";
import { toast } from "react-toastify";
import { ProjectRequestPayload } from "../Projects/ProjectTypes";
import { navigationRequest } from "../../Navigation/NavigationRedux/NavigationRedux";

export const getOnBoardingReducer = (state: reduxInitialState) => state.ProjectReducer;

const getBookings = async (payload: BookingRequestPayload) => {
    payload.page = payload.page ? (Number(payload.page) - 1) : 0;
    let query = new URLSearchParams(payload as any).toString();
    const data = await WebService.getAPI({
        action: API.BOOKING_LIST + query,
        body: {},
        is_session: payload.is_session
    }).then((res: any) => res).catch((e: any) => { return null })
    return data;
};

const getProjets = async (payload: ProjectRequestPayload) => {
    const data = await WebService.getAPI({
        action: API.PROJECT_OPTION_LIST,
        body: {},
    }).then((res: any) => res).catch((e: any) => { return null })
    return data;
};

const deleteBooking = async (payload: string) => {
    const data = await WebService.deleteAPI({ action: API.PROJECT_DELETE + "/" + payload, }).then((res: any) => res).catch((e: any) => { return null })
    return data;
};

const createOrUpdateBooking = async (payload: createOrUpdateBookingInterface) => {
    const isUpdate = payload.data.id ? true : false;
    payload.data.customer_phone = Number(payload.data.customer_phone.toString().replaceAll("-", ""));
    const data = await WebService[isUpdate ? 'putAPI' : 'postAPI']({
        action: isUpdate ? API.BOOKING_UPDATE : API.BOOKING_CREATE,
        body: payload.data,
        id: 'verify-otp-button',
        is_session: payload.data.is_session ?? false
    }).then(async (res: any) => {
        return res
    }).catch((e: any) => { return null })
    return data;
};

function* bookingRequestSaga(action: BookingRequest) {
    try {
        const response: BookingRequestSuccessPayload = yield call(getBookings, action.payload);
        console.log("response", response);

        if (!response) { throw new Error(); }
        yield put(bookingSuccess(response));
    } catch (e: any) {
        yield put(bookingFailure(e.message));
    }
};

function* editBookingPageRequestSaga(action: BookingEditPageRequest) {
    yield put(bookingEditPageSuccess(action.payload.data as BookingInterface));
    yield put({ type: NAVIGATION_REQUEST, payload: routePaths.UPDATE_PROJECT.path });
};

function* deleteBookingRequestSaga(action: BookingRequestFailure) {
    try {
        const data: BookingState = yield select(getOnBoardingReducer);
        const uuid = data.deleteBooking.uuid;
        const response: { message: string } = yield call(deleteBooking, uuid);
        toast.success(response.message);
        if (!response) { throw new Error(); };
        yield put(bookingDeleteSuccess());
        try {
            const projectResponse: BookingRequestSuccessPayload = yield call(getBookings, { page: 1 });
            if (!projectResponse) { throw new Error(); }
            yield put(bookingSuccess(projectResponse));
        } catch {
            yield put(bookingFailure('Failed to fetch project list'));
        }
    } catch {
        yield put(bookingDeleteFailure());
    }
};

function* createOrUpdateBookingRequestSaga(action: BookingCreateRequest) {
    try {
        const response: { message: string } = yield call(createOrUpdateBooking, action.payload as createOrUpdateBookingInterface);
        if (!response) { throw new Error(); }
        toast.success(response.message);
        yield put({ type: NAVIGATION_REQUEST, payload: routePaths.BOOKING.path });
    } catch {
        toast.error('Failed to create booking');
    }
};

function* projectOptionRequestSaga() {
    try {
        const response: BookingRequestSuccessPayload = yield call(getProjets, { page: 1, limit: 100 });
        if (!response) { throw new Error(); };
        if (response.list.length > 0) {
            response.list = response.list.map((item: any) => {
                if (item.project_unit && item.project_unit.length > 0) {
                    item.project_unit = item.project_unit.map((unit: any) => {
                        return { ...unit, value: unit.id, label: unit.unit_name }
                    });
                }
                return { ...item, value: item.id, label: item.project_name }
            }) as ProjectOptionInterface[];
        }
        yield put(bookingProjectOptionsSuccess(response.list));
    } catch {
        yield put(bookingProjectOptionsFailure('Failed to fetch project list'));
    }
};

function* bookingAddOdEditRequestSaga(action: BookingEditPageRequest) {
    yield put(bookingEditPageSuccess(action.payload.data as BookingInterface));
    // yield put(navigationRequest(action.payload.isEdit ? routePaths.BOOKING_UPDATE.path : routePaths.BOOKING_CREATE.path));
};

function* BookingSaga() {
    yield all([takeLatest(BOOKING_REQUEST, bookingRequestSaga)]);
    yield all([takeLatest(BOOKING_EDIT_PAGE_REQUEST, editBookingPageRequestSaga)]);
    yield all([takeLatest(BOOKING_DELETE_REQUEST, deleteBookingRequestSaga)]);
    yield all([takeLatest(BOOKING_CREATE_REQUEST, createOrUpdateBookingRequestSaga)]);
    yield all([takeLatest(BOOKING_PROJECT_OPTIONS_REQUEST, projectOptionRequestSaga)]);
    yield all([takeLatest(BOOKING_CREATE_OR_UPDATE_PAGE_REQUEST, bookingAddOdEditRequestSaga)]);
};

export default BookingSaga;